export default "__VITE_ASSET__CCvnUVBn__"